<!--
 * @Description: 停车订单列表
-->
<template>
  <scroll-layout class="parking-order-list">
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @clean="handleSearchClean"
        @click="handleSearchConfirm"></ykc-search>
    </template>
    <div>
      <ykc-table ref="YkcTable" :data="tableData" :title="tableTitle" :columns="tableColumns">
        <template #headerButtons>
          <div class="table-header-button">
            <ykc-button v-rbac="'order:parkingOrder:export'" type="plain" @click="doExportFile">
              导出
            </ykc-button>
          </div>
        </template>
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          align="right"
          :total="pageInfo.total"
          :current-page.sync="pageInfo.current"
          :page-size.sync="pageInfo.size"
          @current-change="handlePaginationCurrentChange"
          @size-change="handlePaginationSizeChange"></ykc-pagination>
      </ykc-table>
    </div>
  </scroll-layout>
</template>
<script>
  import { parkingOrderPage } from '@/service/apis';
  import { offlineExport } from '@/utils';

  export default {
    name: 'parkingOrderList',
    data() {
      return {
        stationIdData: [],
        searchParams: {
          parkingOrderNo: '',
          tradeSeq: '',
          userAccount: '',
          plateCode: '',
          stationId: '',
          inTimeDate: [],
        },
        tableTitle: '停车订单列表',
        tableData: [],
        tableColumns: [
          { label: '停车订单编号', prop: 'parkingOrderNo', minWidth: '180px' },
          { label: '订单状态', prop: 'ordStatusName', minWidth: '90px' },
          { label: '用户账号', prop: 'userAccount', minWidth: '120px' },
          { label: '道闸名称', prop: 'barrierName', minWidth: '120px' },
          { label: '停车电站', prop: 'stationName', minWidth: '150px' },
          {
            label: '充电订单',
            prop: 'tradeSeqs',
            minWidth: '180px',
            className: 'trade-seq-column',
            scopedSlots: {
              default: ({ row }) => {
                const seqs = row.tradeSeqs || [];
                return seqs.length > 0 ? seqs.join('\n') : '——';
              },
            },
          },
          { label: '车辆号码', prop: 'plateCode', minWidth: '110px' },
          {
            label: '进场时间',
            prop: 'inTime',
            minWidth: '150px',
            scopedSlots: {
              default: ({ row }) => this.formatTime(row.inTime),
            },
          },
          { label: '进场方式', prop: 'inModeName', minWidth: '100px' },
          {
            label: '出场时间',
            prop: 'outTime',
            minWidth: '150px',
            scopedSlots: {
              default: ({ row }) => this.formatTime(row.outTime),
            },
          },
          { label: '出场方式', prop: 'outModeName', minWidth: '110px' },
          {
            label: '停车时长',
            prop: 'stopSecs',
            minWidth: '120px',
            scopedSlots: {
              default: ({ row }) => this.formatSecs(row.stopSecs),
            },
          },
          {
            label: '推送减免时长',
            prop: 'reliefDuration',
            minWidth: '130px',
            scopedSlots: {
              default: ({ row }) => this.formatMinutes(row.reliefDuration),
            },
          },
          {
            label: '车辆支付停车费时间',
            prop: 'payTime',
            minWidth: '160px',
            scopedSlots: {
              default: ({ row }) => this.formatTime(row.payTime),
            },
          },
          {
            label: '订单金额（元）',
            prop: 'actualFee',
            minWidth: '120px',
            scopedSlots: {
              default: ({ row }) => row.actualFee ?? '——',
            },
          },
          {
            label: '优惠停车费（元）',
            prop: 'couFee',
            minWidth: '130px',
            scopedSlots: {
              default: ({ row }) => row.couFee ?? '——',
            },
          },
          {
            label: '现金支付停车费（元）',
            prop: 'cashFee',
            minWidth: '140px',
            scopedSlots: {
              default: ({ row }) => row.cashFee ?? '——',
            },
          },
          {
            label: '电子支付停车费（元）',
            prop: 'efaFee',
            minWidth: '140px',
            scopedSlots: {
              default: ({ row }) => row.efaFee ?? '——',
            },
          },
          { label: '减免状态', prop: 'reliefStatusName', minWidth: '90px' },
          {
            label: '减免失败原因',
            prop: 'reliefFailReason',
            minWidth: '150px',
            scopedSlots: {
              default: ({ row }) => row.reliefFailReason || '——',
            },
          },
        ],
        pageInfo: {
          current: 1,
          size: 10,
        },
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'parkingOrderNo',
            label: '停车订单编号',
            placeholder: '请输入停车订单编号',
          },
          {
            comName: 'YkcInput',
            key: 'tradeSeq',
            label: '关联充电订单编号',
            placeholder: '请输入关联充电订单编号',
          },
          {
            comName: 'YkcInput',
            key: 'userAccount',
            label: '用户账号',
            placeholder: '请输入用户账号',
          },
          {
            comName: 'YkcInput',
            key: 'plateCode',
            label: '车辆号码',
            placeholder: '请输入车辆号码',
          },
          {
            comName: 'YkcDropdown',
            key: 'stationId',
            label: '停车电站',
            placeholder: '请选择停车电站',
            data: this.stationIdData,
          },
          {
            comName: 'YkcDatePicker',
            key: 'inTimeDate',
            label: '入场时间',
            clearable: true,
            placeholder: '请选择入场时间',
          },
        ];
      },
    },
    created() {
      this.doFetchStationInfos();
      this.requestList();
    },
    methods: {
      /**
       * 导出
       */
      doExportFile() {
        offlineExport({
          downloadType: 'parkingOrderExport',
          jsonNode: {
            ...this.searchParams,
          },
        });
      },
      /**
       * @desc 获取停车电站列表
       * */
      doFetchStationInfos() {
        parkingOrderPage
          .findStationList({})
          .then(res => {
            res.map(item => {
              return this.stationIdData.push({
                id: item.stationId,
                name: item.stationName,
              });
            });
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 请求列表数据
       */
      requestList() {
        const reqParams = {
          ...this.searchParams,
          ...this.pageInfo,
        };
        delete reqParams.inTimeDate;
        if (this.searchParams.inTimeDate && this.searchParams.inTimeDate.length > 0) {
          reqParams.startInTime = this.searchParams.inTimeDate[0];
          reqParams.endInTime = this.searchParams.inTimeDate[1];
        }
        parkingOrderPage
          .queryForPage(reqParams)
          .then(res => {
            this.tableData = res.records || [];
            this.pageInfo.total = res.total || 0;
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 点击筛选查询按钮
       * */
      handleSearchConfirm(searchData) {
        this.pageInfo.current = 1;
        Object.assign(this.searchParams, searchData);
        this.requestList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
        this.searchParams.inTimeDate = [];
      },
      /**
       *
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.requestList();
      },
      /**
       *
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.requestList();
      },
      /**
       * 时间格式化
       */
      formatTime(time) {
        if (!time) {
          return '——';
        }
        return String(time).replace('T', ' ').slice(0, 19);
      },
      /**
       * 秒数格式化为时长文本
       */
      formatSecs(secs) {
        if (secs === null || secs === undefined) {
          return '——';
        }
        const total = Number(secs);
        const h = Math.floor(total / 3600);
        const m = Math.floor((total % 3600) / 60);
        const s = total % 60;
        let result = '';
        if (h > 0) {
          result += `${h}小时`;
        }
        if (m > 0) {
          result += `${m}分钟`;
        }
        if (s > 0 || result === '') {
          result += `${s}秒`;
        }
        return result;
      },
      /**
       * 分钟数格式化为分钟文本
       */
      formatMinutes(minutes) {
        if (minutes === null || minutes === undefined) {
          return '——';
        }
        return `${Number(minutes)}分钟`;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .parking-order-list {
    // 提高选择器优先级以覆盖 ykc-table 全局的 nowrap + 固定高度，支持充电订单换行展示
    ::v-deep .el-table .el-table__body-wrapper .trade-seq-column .cell {
      height: auto;
      white-space: pre-line;
      word-break: break-all;
    }
  }
</style>
